import { downgradeComponent } from '@angular/upgrade/static';
import { AiFormFillerComponent } from '@fry/ai-form-filler/ai-form-filler.component';

(function() {
  'use strict';

  angular.module('component.events', [
    'events.directives'
  ])
  .directive('aiFormFiller', downgradeComponent({
    component: AiFormFillerComponent,
    inputs: ['formDefinition'],
    outputs: ['formDataChange']
  }));
})();
